import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

// Components
import BulkActionsMenu from './bulk-actions-menu';
import Checkbox from '../form-fields/checkbox';
import Dropdown from '../form-fields/dropdown';
import TextField from '../form-fields/text-field';

// MUI Components
import Box from '@mui/material/Box';

const SiteTableHeader = ({ search, setSearch, filters, setFilters, getSites, selectedIds, clearSelection, showSitetest, setShowSitetest }) => {

    const [ filterOptions, setFilterOptions ] = useState({});

    const getFilterOptions = () => {
        axios.get('/filter-options', {
            params: {
                filters: Object.keys(filters)
            }
        }).then(response => {
            if( ! response.data.success ){
                toast.error(response.data.message);
                return;
            }
            setFilterOptions(response.data.filter_options);
        });
    }

    useEffect(() => {
        getFilterOptions();
    }, [filters]);

    return (
        <Box className='site-table-header'>
            <Box className='site-table-header-left'>
                <BulkActionsMenu selectedSites={selectedIds} getSites={getSites} clearSelection={clearSelection} />
                {Object.keys(filterOptions).length > 0 && (
                    <>
                        {Object.keys(filterOptions).map((key) => (
                            <Dropdown
                                key={key}
                                label={key.charAt(0).toUpperCase() + key.slice(1)}
                                name={key}
                                options={filterOptions[key]}
                                value={filters[key]}
                                onChange={(e) => setFilters({ ...filters, [key]: e.target.value })}
                            />
                        ))}
                    </>
                )}
            </Box>
            <Box className='site-table-header-right'>
                <Checkbox
                    label='Show sitetest'
                    name='show_sitetest'
                    checked={showSitetest}
                    onChange={setShowSitetest}
                />
                <TextField
                    name='search'
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder='Search Domains'
                />
            </Box>
        </Box>
    )

}

export default SiteTableHeader;